<template>
  <div class="kt-form kt-form--label-right">
    <div class="kt-form__body">
      <div class="kt-section kt-section--first">
        <div class="kt-section__body">
          <div v-if="$slots.title" class="row">
            <!-- <label class="col-xl-3"></label> -->
            <div class="col-lg-9 col-xl-6">
              <h3 class="kt-section__title kt-section__title-sm">
                <slot name="title"></slot>
              </h3>
            </div>
          </div>

          <slot />
        </div>
      </div>

      <div
        class="kt-separator kt-separator--space-lg kt-separator--fit kt-separator--border-solid"
      ></div>

      <div class="kt-form__actions">
        <div class="row">
          <!-- <div class="col-xl-3"></div> -->
          <div class="col-lg-9 col-xl-6">
            <a
              href="#"
              class="btn btn-label-brand btn-bold"
              :class="{ disabled: busy }"
              @click.prevent="$emit('submit')"
            >
              Save changes
            </a>
            <a
              href="#"
              @click.prevent="$router.push({ name: 'home' })"
              class="btn btn-clean btn-bold ml-2"
            >
              Cancel
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FormBase",
  props: {
    busy: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
